var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((Object.entries(_vm.data)),function(ref,index){
var card = ref[0];
var fields = ref[1];
return _c('InfoCard',{key:("info-card-" + index),attrs:{"card-title":card}},_vm._l((Object.entries(fields)),function(ref,index){
var title = ref[0];
var value = ref[1];
return _c('InfoBox',{key:("box-" + index),attrs:{"card-title":card,"title":title,"content":value}})}),1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }